module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-right-down-57526fa08e9584cdcf139df443a33c04.svg";